import BaseApiAction from '@Actions/base-api-action';

export default class SwitchProfile extends BaseApiAction {
  runAction() {
    super.invokeCloudFunction({
      name: 'auth-switchProfile',
      payload: {
        user_id: this._payload.user_id,
        pin: this._payload.pin,
      },
    });
  }
}
